export default {
  deposit: {
    crypto: 'Crypto',
    fiatOrCash: 'Fiat/Cash',
    depositCurrency: 'Deposit Currency',
    chooseNetwork: 'Choose Network',
    depositAddress: 'Deposit address',
    copy: 'Copy',
    copied: 'Copied!',
    close: 'Close',
    more: 'More',
    select: 'Select',
    channel: 'Channel',
    loading: 'Loading...',
    noCurrency: 'No currencies available',
    bonusTip: 'Enjoy a deposit bonus on your first deposits, with up to 200% additional credit.',
    minDeposit: 'Minimum Deposit',
    sendOnly: 'Send only {currency} to this deposit address. Coins will be deposited automatically after {confirmations} network confirmations.',
    depositAmount: 'Deposit Amount',
    enterAmount: 'Enter amount',
    confirmDeposit: 'Confirm Deposit',
    depositTitle: 'Deposit',
    selectChannel: 'Select Channel',
    subtitle: 'Fast, secure and convenient',
    secureEncrypted: 'Secure and Encrypted',
    terms: 'By proceeding, you agree to our Terms & Conditions',
    totalDepositAmount: 'Total deposit amount',
    fee: 'Fee',
    arrivalAmount: 'Amount credited',
    payMethod: 'Payment Method',
    cpf: 'CPF (Optional)',
    enterCpf: 'Enter CPF',
    depositSuccess: 'Deposit successful!',
    depositFailed: 'Deposit failed, please try again.',
    mockArrive: 'Mock Arrival (Test)',
    activity: {
      firstChargeTitle: 'First deposit Registration Event',
      firstChargeSubtitle: 'Register your first deposit to receive exclusive rewards',
      dailyThreeTitle: 'Daily Three deposit',
      dailyThreeSubtitle: 'Complete 3 deposits daily to claim extra bonuses',
      dailyPreviewLabel: 'First Charge Reward',
      upTo: 'Up to {amount} {unit}',
      safeTitle: 'Your funds are safe with us',
      safeDesc: 'We use industry-leading security to protect your transactions and personal information.',
      dailyFirst: 'Daily 1st deposit',
      dailySecond: 'Daily 2nd deposit',
      dailyThird: 'Daily 3rd deposit',
      lossReward: 'Loss Rebate',
      lossRewardSubtitle: 'Get cashback on your losses',
      rebateUpTo: 'Rebate up to {ratio}%',
      notEligible: 'You are no longer eligible for this activity',
      lossNeedSelect: 'Select this activity when depositing to join the cashback',
      claimed: 'Claimed',
      claim: 'Claim',
      noTier: 'No tiers available',
      claimWillOpen: 'Claim opens at {time}',
      claimTimeNotReached: 'Claim is not yet open. Please come back after {time}.',
      bonus: 'Bonus',
      rebate: 'Rebate',
      depositGE: 'Deposit ≥ {amount}',
      lossGE: 'Loss ≥ {amount}',
      claimSuccess: 'Claimed successfully',
      claimFailed: 'Claim failed',
      alreadyClaimed: 'You have already claimed this tier. Please do not click again.',
      lossAlreadyClaimed: 'You have already claimed the loss rebate for this tier. Please do not click again.',
      requireLogin: 'Please log in before claiming.',
      depositNotEnough: 'Your deposit amount has not met the requirement. Keep going!',
      lossNotEnough: 'Your loss amount yesterday did not meet the requirement.',
      onlyHighest: 'This activity reward only allows claiming the highest tier.',
    },
  },
};
